export enum TaxOperationTypeEnum {
  EXEMPT = 1,
  RETENTION_ISR = 2,
}
